import LegalPage, { LegalSection } from "./LegalPage";
import { useContent } from "../lib/contentContext";

export default function Cookies() {
    const { content } = useContent();
    const email = content.contact.email;
    const mail = (
        <a href={`mailto:${email}`} className="link-underline text-gold">
            {email}
        </a>
    );

    return (
        <LegalPage
            eyebrow="Cookies"
            title="Cookie Policy"
            updated={content.legal.effective_date}
        >
            <p>
                This Cookie Policy explains how {content.legal.business_name} uses
                cookies and similar technologies on our website, and how you can
                control them. It should be read together with our{" "}
                <a href="/privacy" className="link-underline text-gold">
                    Privacy Policy
                </a>
                .
            </p>

            <LegalSection title="What are cookies?">
                <p>
                    Cookies are small text files placed on your device when you
                    visit a website. They help the site function, remember your
                    preferences, and understand how the site is used. We also use
                    similar technologies such as local storage and pixels; we
                    refer to all of these as "cookies" here.
                </p>
            </LegalSection>

            <LegalSection title="Categories we use">
                <ul className="list-disc space-y-2 pl-6 text-white/70">
                    <li>
                        <b className="text-white/90">Strictly necessary.</b>{" "}
                        Required for the site to function — session management,
                        security, load balancing, and booking/contact form
                        protection. These cannot be switched off.
                    </li>
                    <li>
                        <b className="text-white/90">Preferences.</b> Remember
                        choices such as a dismissed announcement banner or your
                        reduced-motion setting.
                    </li>
                    <li>
                        <b className="text-white/90">Analytics.</b> Aggregate,
                        de-identified usage data (pages visited, general location,
                        device type) to help us improve the site. We do not use
                        third-party advertising cookies.
                    </li>
                    <li>
                        <b className="text-white/90">Third-party / embedded.</b>{" "}
                        Some pages embed third-party tools — for example, our
                        Cherry financing widget and links to Instagram — which may
                        set their own cookies governed by those providers'
                        policies.
                    </li>
                </ul>
            </LegalSection>

            <LegalSection title="How long cookies last">
                <p>
                    <b className="text-white/90">Session cookies</b> are deleted
                    when you close your browser.{" "}
                    <b className="text-white/90">Persistent cookies</b> remain for
                    a set period or until you delete them, so we can remember your
                    preferences on return visits.
                </p>
            </LegalSection>

            <LegalSection title="Third-party embeds">
                <p>
                    When you interact with embedded content — such as the Cherry
                    financing calculator or an Instagram link — that provider may
                    place cookies and collect information under its own policy. We
                    do not control these cookies. Please review the relevant
                    provider's privacy and cookie notices for details.
                </p>
            </LegalSection>

            <LegalSection title="Managing cookies">
                <p>
                    You can control or delete cookies through your browser
                    settings, and set most browsers to warn you before accepting
                    them. Many browsers also offer a "Do Not Track" signal and
                    private browsing mode. Please note that blocking strictly
                    necessary cookies may affect how the site works.
                </p>
            </LegalSection>

            <LegalSection title="Changes to this policy">
                <p>
                    We may update this Cookie Policy from time to time. The
                    current version and its effective date will always be posted
                    on this page.
                </p>
            </LegalSection>

            <LegalSection title="Contact">
                <p>Questions about our use of cookies? Reach us at {mail}.</p>
            </LegalSection>
        </LegalPage>
    );
}
